export enum FileStatus {
  Complete = 'complete',
  Converting = 'converting',
  Error = 'error',
  InProgress = 'inProgress',
}
